import { useContext } from "react";
import { AppDataContext } from "../contexts/AppDataProvider";

export const useAppData = () => {
  return useContext(AppDataContext);
};
